// src/pages/NewsManagement/EditNews.jsx
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/features/modalSlice';
import { useUpdateNewsMutation } from '../../redux/services/newsService/news.Services';
import { successToast, errorToast } from '../../Utils/toast';

function EditNews({ data }) {
  const dispatch = useDispatch();
  const [updateNews, { isLoading }] = useUpdateNewsMutation();
  
  const [formData, setFormData] = useState({
    id: '',
    title: '',
    description: '',
    category: '',
    author: '',
    status: 'draft',
    publish_date: '',
    meta_title: '',
    meta_description: '',
    meta_keywords: '',
    is_featured: false,
    is_breaking: false,
    image: null
  });
  const [previewImage, setPreviewImage] = useState(null);
  const [existingImage, setExistingImage] = useState(null);

  useEffect(() => {
    if (data) {
      setFormData({
        id: data.id || '',
        title: data.title || '',
        description: data.description || '',
        category: data.category || '',
        author: data.author || '',
        status: data.status || 'draft',
        publish_date: data.publish_date ? new Date(data.publish_date).toISOString().slice(0, 16) : '',
        meta_title: data.meta_title || '',
        meta_description: data.meta_description || '',
        meta_keywords: data.meta_keywords || '',
        is_featured: data.is_featured === 1 || data.is_featured === true,
        is_breaking: data.is_breaking === 1 || data.is_breaking === true,
        image: null
      });
      setExistingImage(data.image_path || null);
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        image: file
      });
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim()) {
      errorToast('News title is required');
      return;
    }
    if (!formData.description.trim()) {
      errorToast('Description is required');
      return;
    }

    try {
      const formDataToSend = new FormData();
      Object.keys(formData).forEach((key) => {
        if (key === 'image' && formData.image) {
          formDataToSend.append('image', formData.image);
        } else if (key !== 'image' && key !== 'id') {
          formDataToSend.append(key, formData[key]);
        }
      });

      const response = await updateNews({ 
        id: formData.id, 
        data: formDataToSend 
      }).unwrap();
      
      successToast(response?.message || 'News updated successfully');
      dispatch(closeModal());
    } catch (error) {
      console.error('Update error:', error);
      errorToast(error?.data?.message || 'Failed to update news');
    }
  };

  return (
    <div className="edit-news-container">
      <form onSubmit={handleSubmit}>
     
      

        <div className="row">
          <div className="col-md-6 mb-3">
               <div className="mb-3">
          <label className="form-label fw-bold">
            News Title <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="Enter news title"
            required
            autoFocus
          />
        </div>

          </div>
          <div className="col-md-6 mb-3">
              <div className="mb-3">
          <label className="form-label fw-bold">
            Description <span className="text-danger">*</span>
          </label>
          <textarea
            className="form-control"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Enter news description"
            rows="4"
            required
          />
        </div>
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Category</label>
            <input
              type="text"
              className="form-control"
              name="category"
              value={formData.category}
              onChange={handleChange}
              placeholder="Enter category"
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Author</label>
            <input
              type="text"
              className="form-control"
              name="author"
              value={formData.author}
              onChange={handleChange}
              placeholder="Enter author name"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Status</label>
            <select
              className="form-control"
              name="status"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="draft">Draft</option>
              <option value="published">Published</option>
              <option value="archived">Archived</option>
            </select>
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Publish Date</label>
            <input
              type="datetime-local"
              className="form-control"
              name="publish_date"
              value={formData.publish_date}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Meta Title</label>
            <input
              type="text"
              className="form-control"
              name="meta_title"
              value={formData.meta_title}
              onChange={handleChange}
              placeholder="Enter meta title"
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Meta Description</label>
            <input
              type="text"
              className="form-control"
              name="meta_description"
              value={formData.meta_description}
              onChange={handleChange}
              placeholder="Enter meta description"
            />
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Meta Keywords</label>
          <input
            type="text"
            className="form-control"
            name="meta_keywords"
            value={formData.meta_keywords}
            onChange={handleChange}
            placeholder="Enter meta keywords (comma separated)"
          />
        </div>

        <div className="mb-3">
          <div className="d-flex gap-4">
            <label className="d-flex align-items-center gap-2">
              <input
                type="checkbox"
                name="is_featured"
                checked={formData.is_featured}
                onChange={handleChange}
              />
              Featured News
            </label>
            <label className="d-flex align-items-center gap-2">
              <input
                type="checkbox"
                name="is_breaking"
                checked={formData.is_breaking}
                onChange={handleChange}
              />
              Breaking News
            </label>
          </div>
        </div>

        {/* Current Image */}
        {existingImage && !previewImage && (
          <div className="mb-3">
            <label className="form-label fw-bold">Current Image</label>
            <div>
              <img 
                src={existingImage}
                alt="Current News" 
                style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'cover' }}
                className="img-thumbnail"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/placeholder-image.png';
                }}
              />
            </div>
          </div>
        )}

        {/* Image Upload */}
        <div className="mb-3">
          <label className="form-label fw-bold">Change Image</label>
          <input
            type="file"
            className="form-control"
            name="image"
            onChange={handleFileChange}
            accept="image/*"
          />
        </div>

        {/* Image Preview */}
        {previewImage && (
          <div className="mb-3">
            <label className="form-label fw-bold">New Image Preview</label>
            <div>
              <img 
                src={previewImage} 
                alt="New News Preview" 
                style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'cover' }}
                className="img-thumbnail"
              />
            </div>
          </div>
        )}

        <div className="d-flex justify-content-end gap-2 mt-4">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => dispatch(closeModal())}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Saving...
              </>
            ) : (
              'Save Changes'
            )}
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditNews;